import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import { FormGroup, TextField, Grid, IconButton, Typography } from '@mui/material';
import React from 'react';

import WsColors from '../../../WsColors';
import { WsTypoVariants, WsTypoColors } from '../../WsTypography/WsTypography';

export interface TextEditProps {
  fieldName: string;
  defaultValue: string;
  onConfirm: (key: string, value: string) => void;
  textVariant?: WsTypoVariants;
  color?: WsTypoColors;
  disabled?: boolean;
}

const TextEdit = ({
  fieldName,
  defaultValue,
  onConfirm,
  textVariant,
  color,
  disabled = false,
}: TextEditProps) => {
  const [isEdit, setIsEdit] = React.useState<boolean>(false);
  const [editValue, setEditValue] = React.useState<string>(defaultValue);
  const [tempValue, SetTempValue] = React.useState<string>(defaultValue);

  const disableFields = [
    'Languages Known',
    'Profile Urls',
    'Social Link',
    'Potential Net Margin',
    'Net Revenue',
  ];

  const isEditable = !disabled && !disableFields.includes(fieldName);

  return (
    <>
      {isEdit && isEditable ? (
        <FormGroup>
          <TextField
            onChange={(event) => {
              SetTempValue(event.target.value);
            }}
            value={tempValue}
            inputProps={{ style: { padding: '4px 7px' } }}
            disabled={disabled} // Add disabled prop to TextField
          />
          <Grid container display="flex" justifyContent="end" mt={0.5}>
            <Grid item spacing={1}>
              <IconButton onClick={() => setIsEdit(false)} sx={{ borderRadius: 1.5 }}>
                <CloseIcon />
              </IconButton>
              <IconButton
                onClick={async () => {
                  await onConfirm(fieldName, tempValue);
                  setEditValue(tempValue);
                  setIsEdit(false);
                }}
                sx={{ borderRadius: 1.5, color: WsColors.TheBlues500 }}
                disabled={disabled}
              >
                <DoneIcon />
              </IconButton>
            </Grid>
          </Grid>
        </FormGroup>
      ) : (
        <Typography
          variant={textVariant}
          color={color}
          sx={{
            overflow: 'hidden',
            display: 'block',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            ...(isEditable ? { cursor: 'pointer' } : {}),
          }}
          onClick={() => {
            isEditable && setIsEdit(!isEdit);
          }}
        >
          {editValue}
        </Typography>
      )}
    </>
  );
};

export default TextEdit;
